import axios from 'axios';
import { stringify } from 'qs';
import { v4 as uuidv4 } from 'uuid';
import { getCookie } from '@/utils-v2/libs/cookieWrapper.ts';
import { pushApiError, sentryDebug } from '@/utils-v2/libs/sentry';
import { transformError } from '@/api/transform-error';
import { errorHandlerWrapper, errorHandlerHistoryClear } from '@/utils-v2/plugins/errorHandler/helpers.js';
import { authService } from './modules/auth/auth';

const client = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  paramsSerializer: stringify,
  headers: {
    'Accept-Language': localStorage.getItem('lang') || 'ru',
  },
});

const telegramClient = axios.create({
  baseURL: import.meta.env.VITE_APP_BOT_URL,
});

function resolveError(error) {
  sentryDebug({ title: 'API ERROR', message: transformError(error) });
  return Promise.reject(transformError(error));
}

function successResponseHandler(response) {
  errorHandlerHistoryClear(response.request.responseURL);

  return response.data;
}

async function failedResponseHandler(error) {
  const errorCode = error?.response?.status;

  // if (errorCode === 401 && getCookie('auth_token')) {
  //   // await authService.logout();
  // } else {
  //   errorHandlerWrapper(error);
  //   if (errorCode !== 400) {
  //     pushApiError(error.response);
  //   }
  // }

  errorHandlerWrapper(error);
  if (errorCode !== 400) {
    pushApiError(error.response);
  }

  return Promise.reject(error);
}

client.interceptors.request.use(
  config => {
    config.headers['X-Idempotency-key'] = uuidv4();
    config.headers['Content-Type'] = 'application/json';

    if (getCookie('auth_token')) {
      config.headers.Authorization = `JWT ${getCookie('auth_token')}`;
    }

    return config;
  },
  err => {
    resolveError(err);
    return Promise.reject(err);
  },
);

client.interceptors.response.use(successResponseHandler, failedResponseHandler);

export { client, telegramClient };
